// UI-07: Rupiah input mask helpers, kept DOM-free for `node --test`.
const formatter = new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 })

export function digits(text) {
  return String(text ?? "").replace(/\D/g, "").replace(/^0+(?=\d)/, "")
}

export function formatRupiah(value) {
  const raw = digits(value)
  return raw === "" ? "" : `Rp ${formatter.format(Number(raw))}`
}
